import { $curScene, $tourData } from '@stores/dataStores';
import { $GateSandTableId } from '@stores/editingStores';
import classNames from 'classnames';
import { useStore, useStoreMap } from 'effector-react';
import {
  isSTImageOrMatrix,
  isSTMap,
} from '../../../sandTable/utils/sandTableTypeCheck';
import { MapContainer } from './MapContainer';
import { MatrixContainer } from './MatrixContainer';

export function SceneSandTable() {
  const id = useStore($GateSandTableId.state);
  const scene = useStore($curScene);
  const data = useStoreMap({
    store: $tourData,
    keys: [id],
    fn: (state) => {
      if (!id) return null;
      return state.sandBox?.find((item) => item.id === id) ?? null;
    },
  });

  if (!scene) return null;

  const show = id || isSTMap(data) || isSTImageOrMatrix(data);

  return (
    <div
      className={classNames(
        'absolute top-10 right-10 rounded bg-black-black bg-opacity-50 p-3',
        { hidden: !show }
      )}
    >
      <div className="relative h-190 w-190 overflow-hidden rounded">
        <MapContainer scene={scene} data={isSTMap(data) ? data : null} />
        <MatrixContainer
          scene={scene}
          data={isSTImageOrMatrix(data) ? data : null}
        />
      </div>
    </div>
  );
}
